import { Slide, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import useAdminContext from "../AdminContextProvider";
import FindMatch from "./FindMatch";
import RegistrationSearchCriteria from "./RegistrationSearchCriteria";
import RegistrationSearchResults from "./RegistrationSearchResults";

const toolbarHeight = 64;
const footerHeight = "fit-content";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    position: "relative",
    overflowY: "hidden",
  },
  searchContentContainer: {
    height: `calc(100% - ${footerHeight + toolbarHeight}px)`,
    overflowY: "auto",
    overflowX: "hidden",
  },
  searchContent: { padding: theme.spacing(0.5) },
  findMatchContainer: {
    height: footerHeight,
    position: "relative",
    padding: theme.spacing(0.5),
    marginBottom: "1rem",
  },
  findMatch: {
    height: footerHeight,
  },
}));

export default function AdminSearch() {
  const classes = useStyles();

  const [searchCriteria, setSearchCriteria] = React.useState({});
  const adminContext = useAdminContext();

  return (
    <div className={classes.root}>
      <div className={classes.searchContentContainer}>
        <div className={classes.searchContent}>
          <Typography variant="h2">Search</Typography>
          <RegistrationSearchCriteria searchCriteria={searchCriteria} setSearchCriteria={setSearchCriteria} />
          <RegistrationSearchResults
            inputSearchCriteria={searchCriteria}
            selectedRegistrationId={adminContext.selectedRegistration?.registrationId}
          />
        </div>
      </div>
      <div className={classes.findMatchContainer}>
        <Slide direction="up" in={Boolean(adminContext.selectedRegistration)} mountOnEnter unmountOnExit>
          <div>
            <FindMatch className={classes.footerHeight} registration={adminContext.selectedRegistration} />
          </div>
        </Slide>
      </div>
    </div>
  );
}
